<script setup lang="ts">
const props = defineProps<{
  formId: id
  alignLeft?: boolean
}>()

const { data: form } = useFetchForm(props.formId)

const submitted = ref(false)

function handleSubmitted(values: Record<string, any>) {
  console.log(values)
  // submitted.value = true
}
</script>

<template>
  <ContentBlockViewPartialContainer>
    <FormBuilderRenderer
      v-if="form && !submitted"
      :form="form"
      :align="alignLeft ? 'left' : 'center'"
      @submit="handleSubmitted"
    />

    <FormBuilderSuccessCard v-if="form && submitted" :form="form" />
  </ContentBlockViewPartialContainer>
</template>
